import * as qs from 'qs';
export class UrlHelper {
    static parseQueryStringFromLocation(window) {
        return this.parseQueryStringFromStr(window.location.search);
    }
    static parseQueryStringFromStr(str) {
        let queryString = str;
        if (!queryString) {
            return {};
        }
        if (this._startsWith(queryString, '?')) {
            queryString = queryString.substring(1);
        }
        const parsedObj = qs.parse(queryString, { parseArrays: true, allowDots: true });
        const normalizedObj = {};
        if (parsedObj) {
            for (const key in parsedObj) {
                if (parsedObj[key] !== undefined && parsedObj[key] !== null) {
                    normalizedObj[key] = parsedObj[key].toString();
                }
            }
        }
        return normalizedObj;
    }
    static stringifyObjToQueryString(obj) {
        if (!obj) {
            return '';
        }
        const queryString = qs.stringify(obj, { arrayFormat: 'indices', allowDots: true });
        return queryString;
    }
    static addQueryParamToStr(queryString, key, value) {
        const currentQueryStringObj = this.parseQueryStringFromStr(queryString);
        const newQueryStringObj = {
            ...currentQueryStringObj,
            [key]: value,
        };
        const newQueryString = this.stringifyObjToQueryString(newQueryStringObj);
        return newQueryString;
    }
    static _startsWith(str, searchString, position = 0) {
        return str.substr(position, searchString.length) === searchString;
    }
}
//# sourceMappingURL=url-helper.js.map